import React from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { getIngresosPeriodo } from '../store/thunk';
import { FiAlertTriangle, FiSearch } from 'react-icons/fi';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { Table } from '../../../../components/Table';

export const Ganancias = () => {

    let f = new Date(); let dia = f.getDate(); let mes = f.getMonth() + 1; if (dia < 10) dia = "0" + dia; if (mes < 10) mes = "0" + mes; let today = f.getFullYear() + "-" + mes + "-" + dia;
    const dispatch = useDispatch();
    const { isLoading, ingresos, dateStart, dateEnd, msg } = useSelector(state => state.reportsFinance);
    const { register, control, handleSubmit, watch, reset, getValues, setValue, formState: { errors } } = useForm({ model: 'all' });


    const searchData = (data) => {
        dispatch(getIngresosPeriodo(data.fechaInicial, data.fechaFinal, data.periodo))
    }

    const chartData = transformData(ingresos);
    const formasPago = [...new Set(ingresos.map(d => d.FORMA_PAGO))];

    const maxValue = Math.max(...chartData.flatMap(d =>
        ingresos.map(servicio => d[servicio] || 0)
    ));

    const yAxisMax = Math.ceil((maxValue + 2) / 2) * 5; // redondeo opcional


    let data = [...ingresos];
    let columns = [
        {
            header: 'PERIODO',
            dataIndex: 'PERIODO',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'SIGLAS',
            dataIndex: 'CODE',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'FORMA DE PAGO',
            dataIndex: 'FORMA_PAGO',
            classHeader: 'text-start',
            classRow: 'text-start',
        },
        {
            header: 'MONTO ($)',
            dataIndex: 'ACUMULADO',
            classHeader: 'text-end',
            classRow: 'text-end',
            renderer: (value) => Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value),
        },

    ];

    function transformData(data) {
        const agrupaciones = {};

        data.forEach(row => {
            const agrupacion = row.PERIODO;
            const nombre = row.FORMA_PAGO;
            const valor = parseFloat(row.ACUMULADO);

            if (!agrupaciones[agrupacion]) {
                agrupaciones[agrupacion] = { AGRUPACION: agrupacion };
            }

            agrupaciones[agrupacion][nombre] = valor;
        });

        return Object.values(agrupaciones);
    }

    return (
        <div className='row'>
            <h1 className="h3 mb-3 mt-3">Reporte de Ingresos</h1>

            <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                <div className=''>
                    <div className='card-header border-bottom'>
                        <h5 className='card-title mb-0 text-black'>Filtros</h5>
                    </div>
                    <div className='card-body'>
                        <form className="row " onSubmit={handleSubmit(searchData)}>
                            <div className="col-12 mb-2">
                                <label className="form-label">Fecha Inicio:</label>
                                <input type="date" className="form-control" defaultValue={today} {...register("fechaInicial", { required: 'Introduce fecha de inicio' })} />
                                {
                                    errors.fechaInicial &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaInicial.message}</small></span>
                                    </div>
                                }
                            </div>
                            <div className="col-12 mb-2">
                                <label className="form-label">Fecha Inicio:</label>
                                <input type="date" className="form-control" defaultValue={today} {...register("fechaFinal", { required: 'Introduce fecha final' })} />
                                {
                                    errors.fechaFinal &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.fechaFinal.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className="col-12 mb-2">
                                <label className="form-label">Periodo:</label>
                                <select className="form-select" aria-label="Default select example" {...register("periodo", { required: 'Seleccione peridoo' })}>
                                    <option value="1">Dia</option>
                                    <option value="2">Semana</option>
                                    <option value="3">Mes</option>
                                </select>
                                {
                                    errors.periodo &&
                                    <div className='text-left-5 mt-2'>
                                        <FiAlertTriangle size="18" color="#dc3545" />
                                        <span className='text-left-10 fw-bold text-danger'><small>{errors.periodo.message}</small></span>
                                    </div>
                                }
                            </div>

                            <div className='col-12 text-end'>
                                <button type="submit" className="btn btn-outline-dark ">  <FiSearch size={20} /> Buscar</button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
            <div className="col-12 col-sm-12 col-md-10 col-lg-10 col-xl-10 col-xxl-10">
                <div className="">
                    <div className="card-header border-bottom ">
                        <h5 className="card-title mb-0 text-black">Grafico</h5>
                    </div>
                    <div className="card-body">
                        <ResponsiveContainer width="100%" height={400}>
                            <LineChart data={chartData}>
                                <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
                                <XAxis dataKey="AGRUPACION" />
                                <YAxis domain={[0, yAxisMax]} />
                                <Tooltip />
                                <Legend />
                                {formasPago.map((nombre, idx) => (
                                    <Line
                                        key={idx}
                                        type="monotone"
                                        dataKey={nombre}
                                        stroke={`hsl(${idx * 60}, 70%, 50%)`}
                                        strokeWidth={2}
                                    />
                                ))}
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>


                <div className="">
                    <div className="card-header border-bottom ">
                        <h5 className="card-title mb-0 text-black">Listado de Ingresos</h5>
                    </div>
                    <div className="card-body">
                        <Table columns={columns} data={data} function_={[]} placeholderSearch="Buscar Ingreso" showPagination={true} showControls={true} showTotals={false} />
                    </div>
                </div>
            </div>
        </div>
    )
}
